import { Log } from '@lightningjs/sdk'
import { REQUEST_STATUS } from '../../enum'
import { Helper } from '../../helper'
import { parseChannels, parseVideos } from '../../parser'
import { ItemNode } from "./ItemNode"
import { fetchData, getFetchUrl } from '../../models/data-service'


export class PromiseResolver {
  promise: Promise<RowList>
  resolve: any
  reject: any

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}

export default class RowList {
  videosCount = -1
  index = -1
  limit = 20
  videos: (ItemNode | undefined)[] = []
  //groupId = groupId
  isInitialized = false
  initFetcingStatus = REQUEST_STATUS.NONE
  fetchedPageList: REQUEST_STATUS[] = []
  totalPages = 0
  fetchedPagePromise: PromiseResolver[] = []

  description: ''
  dynamic_deeplink: boolean
  feed_type: string
  name: string
  keys: any
  season:string = ''
  row_height: number
  row_item_height: number
  row_item_width: number
  row_type: string
  rowstyle: string
  url: string
  isInitialFetch: any
  id: any;
  playlistRowName: ''
  isNumberRow: boolean
  title_image: string = ''

  constructor(rowData: any) {
    this.description = rowData.description
    this.dynamic_deeplink = Helper.toBoolean(rowData.dynamic_deeplink)
    this.isNumberRow=Helper.toBoolean(rowData.isNumberRow, false)
    this.feed_type = rowData.feed_type
    this.name = rowData.name
    this.keys = Helper.getQueryParamValueFromUrl(rowData.url,'keys')
    this.row_height = rowData.row_height
    this.row_item_height = rowData.row_item_height
    this.row_item_width = rowData.row_item_width
    this.row_type = rowData.row_type
    this.rowstyle = rowData.rowstyle
    this.url = rowData.url
    this.season = rowData.season
    this.id = rowData.id
    this.playlistRowName = rowData.name
    this.title_image = rowData?.title_image
  }

  setPageData = (count: number, limit: number, itemList: ItemNode[]) => {
    if (this.url.indexOf('searchType=popular') > -1 && count > 100) {      // limit the popular search results to 100 items instead of actual 1000
      count = 100
    }
    this.videosCount = count
    this.limit = limit
    this.videos = itemList
    if (this.name.toLocaleLowerCase() == 'general') {
      this.videosCount = this.videos.length
    }
    if (count > limit) {
      this.totalPages = Math.ceil(count / limit)
    } else {
      this.totalPages = 1
    }
  }

  resetList = () => {
    this.videosCount = -1
    this.limit = 20
    this.videosCount = 0
    this.limit = 20
    this.videos = []
    //groupId = groupId
    this.initFetcingStatus = REQUEST_STATUS.NONE
    this.fetchedPageList = []
    this.totalPages = 0
  }

  reloadList = () => {
    this.resetList()
    return this.fetchMoreVideos(0)
  }

  getPageNoFromItemIndex = (itemIndex: number) => {
    return Math.floor(itemIndex / this.limit)
  }

  fetchMoreVideos = (newPageNo: number) => {
    let promiseResolver: PromiseResolver | undefined = this.fetchedPagePromise[newPageNo]

    if (promiseResolver == undefined) {
     Log.info('promiseResolver -------:', promiseResolver)
      promiseResolver = new PromiseResolver()
      this.fetchedPagePromise[newPageNo] = promiseResolver
    } else {
     Log.info('promiseResolver -------:', promiseResolver)
      //promiseResolver?.resolve(this)
      return promiseResolver?.promise
    }

    this.fetchedPageList[newPageNo] = REQUEST_STATUS.FETCHING
    if (!this.isInitialized) {
      this.initFetcingStatus = REQUEST_STATUS.FETCHING
    }

    fetchData(getFetchUrl(this.url) + '&start-index=' + newPageNo)
      .then((response) => {
        let data = response.data
        let newVideos: ItemNode[]
        const limit = data.params ? data.params.limit : 20

        if (data.status == 'fail') {
          if (!this.isInitialized) {
            this.initFetcingStatus = REQUEST_STATUS.FAIL
            this.isInitialized = true
          }
          this.fetchedPageList[newPageNo] = REQUEST_STATUS.FAIL
        } else {
          if (data.channels) {
            newVideos = parseChannels(data)
          } else {
            newVideos = parseVideos(data)
          }          
          if (!this.isInitialized) {
            this.setPageData(data.count, limit, newVideos)
            this.initFetcingStatus = REQUEST_STATUS.OK
            this.isInitialized = true
          }
          const startIndx = newPageNo * this.limit
          newVideos.map((item, index) => {
            this.videos[startIndx + index] = item
          })
          this.fetchedPageList[newPageNo] = REQUEST_STATUS.OK
        }
        promiseResolver?.resolve(this)
      })
      .catch((error) => {
        Log.error('row-Model: error', 'fetching items: fail', [error])
        if (!this.isInitialized) {
          this.initFetcingStatus = REQUEST_STATUS.FAIL
          this.isInitialized = true
        }
        this.fetchedPageList[newPageNo] = REQUEST_STATUS.FAIL
        promiseResolver?.resolve(this)
      })
    // this.fetchedPagePromise[newPageNo] = promise
    return promiseResolver.promise
  }

  destroy() {
    this.resetList()
  }
}
